<div
  class="flex-1 card"
  [ngClass]="cssClass()"
>
  <div class="p-6 flex flex-col">
    <div class="mb-8">
      <div class="flex justify-between items-center mb-8">
        <span class="text-2xl font-bold text-primary">{{ chartCase() }}</span>
      </div>
      <hr class="border-gray-300" />
    </div>

    <!-- end::Header-->

    <!-- begin::Body-->
    <div class="card-body">
      <!-- begin::Chart-->
      <div #chartRef>
        @if (chartOptions.series) {
        <apx-chart
          [series]="chartOptions.series!"
          [chart]="chartOptions.chart!"
          [stroke]="chartOptions.stroke!"
          [dataLabels]="chartOptions.dataLabels!"
          [colors]="chartOptions.colors!"
          [fill]="chartOptions.fill!"
          [markers]="chartOptions.markers!"
          [xaxis]="chartOptions.xaxis!"
          [yaxis]="chartOptions.yaxis!"
          [tooltip]="chartOptions.tooltip!"
        ></apx-chart>
        }
      </div>
      <!-- end::Chart-->
    </div>
  </div>
</div>
